module.exports = __webpack_public_path__ + "static/struff-gray-87fcabbca2e8a60ad8b6d34acb80dc49.png";